import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import centralApiAxios from "../../axios/centralApiAxios";
import { CREATE_PAYMENTMETHOD_NEW_RECORD, GET_PAYMENTMETHOD_NEW_RECORD} from '../actions';

import {
    createPaymentMethodItemNewRecordSuccess,
    createPaymentMethodItemNewRecordError,
    getPaymentMethodItemNewRecordSuccess,
    getPaymentMethodItemNewRecordError
} from './actions';

const CREATE_NEW_RECORD_ERROR = "New record success.";

const createPaymentMethodNewRecordAsync = async (newRecord) => {

  try{
    if (newRecord.accountId > 0)
    {
      const responseObject = await centralApiAxios.put("vocabularies?id="+ newRecord.accountId, newRecord);

      return {
      newsItem: responseObject.data,
      accountId: responseObject.data.accountId,
      trashed : newRecord.trashed,
      isNewsItemCreate: !(newRecord.accountId > 0),
      message: ""
      };
    }
    else{
      const responseObject = await centralApiAxios.post("vocabularies?id="+ newRecord.accountId, newRecord);

      return {
      newsItem: responseObject.data,
      accountId: responseObject.data.accountId,
      trashed : newRecord.trashed,
      isNewsItemCreate: !(newRecord.accountId > 0),
      message: ""
      };
    }

  }
  catch (err) {
    // alert(err);
    return {
       message: CREATE_NEW_RECORD_ERROR,
    };
  }
};

function* createPaymentMethodItemNewRecord({ payload }) {
     const { history } = payload;
    try {
      const resultReturned = yield call(createPaymentMethodNewRecordAsync, payload.newRecord.paymentMethodItemRecord);
      if (!resultReturned.message) {
        yield put(createPaymentMethodItemNewRecordSuccess(resultReturned));
        if (resultReturned.isNewsItemCreate)
        {
           // history.push("/app/vocabulary-overview/"+ resultReturned.vocabulary_id);
        }
        if (payload.newRecord.catalogItemRecord.trashed == true) {
          history.push("/app/RecordListing/Vocabularies");
          window.location.reload();
        }
        else{
          window.location.reload();
        }
      } else {
        yield put(createPaymentMethodItemNewRecordError(resultReturned.message));
      }
    } catch (errorExp) {
      yield put(createPaymentMethodItemNewRecordError(CREATE_NEW_RECORD_ERROR));
    }
}

const getPaymentMethodItemNewRecordAsync = async (payload) => {

  if (payload.accountId == 0)
  {
    return {
      accountItemRecord: undefined,
      accountId: 0,
      message: ""
    };
  }
  try{
    const responseObject = await centralApiAxios.get(`/vocabularies/${  payload.accountId}?lcid=1033`);
    return {
    accountItemRecord: responseObject.data,
    accountId: responseObject.data.accountId,
    message: ""
    };
  }
  catch (err) {
    // alert(err);
    return {
       message: CREATE_NEW_RECORD_ERROR,
    };
  }
};

function* getPaymentMethodItemNewRecord({ payload }) {
    // const { history } = payload;
    try {
      const resultReturned = yield call(getPaymentMethodItemNewRecordAsync, payload);
      if (!resultReturned.message) {
        yield put(getPaymentMethodItemNewRecordSuccess(resultReturned));
      } else {
        yield put(getPaymentMethodItemNewRecordError(resultReturned.message));
      }
    } catch (errorExp) {
      yield put(getPaymentMethodItemNewRecordError(CREATE_NEW_RECORD_ERROR));
    }
}
// eslint-disable-next-line
export function* watchCreateRecords(newRecord) {
  yield takeEvery(CREATE_PAYMENTMETHOD_NEW_RECORD, createPaymentMethodItemNewRecord);
}
// eslint-disable-next-line
export function* watchGetPaymentMethodItemNewRecord(newRecord) {
  yield takeEvery(GET_PAYMENTMETHOD_NEW_RECORD, getPaymentMethodItemNewRecord);
}

export default function* rootSaga() {
    yield all([
        fork(watchGetPaymentMethodItemNewRecord),
        fork(watchCreateRecords)
    ]);
}
